<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm label-width="80" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem>
          <ElInput v-model="keyword" placeholder="请输入素材ID或者名称" @keyup.enter.native="sendEvent">
            <i slot="append" @click="sendEvent" class="el-icon-search"></i>
          </ElInput>
        </ElFormItem>
        <ElFormItem label="创建人">
          <ThrottleSelector
            v-model="agentId"
            :list="agentData"
            @change="sendEvent"
            style="width: 160px"
            placeholder="全部"
            filterable
            clearable
          />
        </ElFormItem>
        <ElFormItem label="媒体">
          <ThrottleSelector
            v-model="mediaId"
            :list="dropMedias"
            @change="sendEvent"
            style="width: 160px"
            placeholder="全部"
            filterable
            clearable
          />
        </ElFormItem>

        <ElFormItem class="bg-transparent">
          <div class="operate-btns">
            <ElButton class="template-btn" @click="$emit('on-down')">模板下载</ElButton>
            <Upload action="" :before-upload="preUpload" accept="application/vnd.ms-excel,.xls,.xlsx,.csv">
              <ElButton type="primary">导入素材消耗</ElButton>
            </Upload>
          </div>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
import { trim } from '@/common/js/utils'
import ThrottleSelector from '@/components/throttle-select/index.vue'
export default {
  name: 'designExpendFilter',
  components: { ThrottleSelector },
  props: {
    dropMedias: {
      type: Array
    },
    agentData: {
      type: Array
    }
  },
  methods: {
    sendEvent() {
      const params = {
        opId: this.agentId === '' ? undefined : this.agentId,
        mediaId: this.mediaId === '' ? undefined : this.mediaId,
        keyWord: trim(this.keyword)
      }
      this.$emit('on-change', params)
    },

    preUpload(file) {
      this.emitImport(file)
      return false
    },
    emitImport(file) {
      this.$emit('on-import', file)
    }
  },
  data() {
    return {
      keyword: '',
      agentId: '', // 创建人
      mediaId: '' // 媒体
    }
  },
  created() {
    // 初始化
    this.sendEvent()
  }
}
</script>
<style lang="scss" scoped>
.operate-btns {
  display: flex;
  .template-btn {
    margin-right: 3px;
  }
  ::v-deep .ivu-upload-list {
    margin-top: 0;
  }
}
</style>
